import { useQuery } from '@apollo/client';
import { useCountry } from '../../components/CountrySelector';
import { GET_RETURN_QUERY, GetReturnQuery, GetReturnQueryVariables } from './return.rest';

export const useReturn = (shipmentNumber: string) => {
  const { country } = useCountry();
  const { data, loading, error } = useQuery<GetReturnQuery, GetReturnQueryVariables>(
    GET_RETURN_QUERY,
    { variables: { countryCode: country.alpha2Code, shipmentNumber } }
  );

  return {
    returnOrder: data?.getReturn.data[0],
    returnOrderItems: data?.getReturn.included,
    loading,
    error
  };
};
